// extracted by css-extract-rspack-plugin
export default {"bordered":"bordered-3aIId","flex":"flex-2ExKP"};